export enum QuestionnaireImportance {
	IMPORTANT = "IMPORTANT",
	NONE = "NONE",
	STOP = "STOP",
}
